/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const loginButtonSX: SxProps<Theme> = {
	width: { xs: '150px', sm: '200px', md: '200px', lg : '200px'},
	'&:focus-visible':{ // focus-visible is activated only when element is focussed using keyboard
				outlineOffset: 4,
				borderRadius: 0.1,
				outline:'1px solid !important'
			}
}; 
